import { useEffect, useState } from 'react';
import supabase from '../../config/supabaseClient';


function Homily() {

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [buttonName, setButtonName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uniqueFileName, setUniqueFileName] = useState("");

    useEffect(() => {
        fetchDocs();
    }, []);
    
    useEffect(() => {
        const checkAuth = async () => {
          const user = await supabase.auth.getUser();
          setIsAuthenticated(!!user.data.user);
          console.log("Auth!!", !!user.data.user);
        };
        checkAuth();
      }, []);

    const [docs, setDocs] = useState(null);
    const [fetchError, setFetchError] = useState(null);

    const fetchDocs = async () => {
        const { data, error } = await supabase.from('docs').select('*');

        if (error) {
            setFetchError('Could not fetch docs');
            setDocs(null);
            console.log(error);
        }

        if (data) {
            setDocs(data);
            setFetchError(null);
            console.log('Supabase Docs:', data);
        }
    };

    // Generate ultra-unique filename when user selects a file
    const handleFileSelection = (e) => {
        console.log("File selection handler called");
        const file = e.target.files[0];
        console.log("Selected file:", file);
        
        if (file) {
            console.log("Processing file:", file.name);
            // Create absolutely unique filename using multiple entropy sources
            const now = new Date();
            const timestamp = now.getTime(); // Unix timestamp
            const nanoTime = performance.now().toString().replace('.', '_'); // High precision time
            const randomPart1 = Math.random().toString(36).substring(2, 15);
            const randomPart2 = Math.random().toString(16).substring(2, 10);
            const randomPart3 = (Math.random() * 1000000).toString(36);
            const dateString = now.toISOString().replace(/[:.T-]/g, '');
            
            const fileExtension = file.name.split('.').pop();
            const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z0-9]/g, '_');
            
            // Ultra-unique filename with multiple random components
            const newUniqueFileName = `${fileNameWithoutExt}_${timestamp}_${dateString}_${nanoTime}_${randomPart1}_${randomPart2}_${randomPart3}.${fileExtension}`;
            
            console.log("Setting selectedFile to:", file);
            console.log("Setting uniqueFileName to:", newUniqueFileName);
            
            setSelectedFile(file);
            setUniqueFileName(newUniqueFileName);
            console.log("Generated ultra-unique filename:", newUniqueFileName);
        } else {
            console.log("No file selected, clearing states");
            setSelectedFile(null);
            setUniqueFileName("");
        }
    };

    

      

    // Function to generate a completely new unique filename
    const generateNewUniqueFilename = (originalFile) => {
        const now = new Date();
        const timestamp = now.getTime() + Math.floor(Math.random() * 10000); // Add randomness to timestamp
        const nanoTime = performance.now().toString().replace('.', '_');
        const randomPart1 = Math.random().toString(36).substring(2, 20);
        const randomPart2 = Math.random().toString(16).substring(2, 15);
        const randomPart3 = (Math.random() * 9999999).toString(36);
        const dateString = now.toISOString().replace(/[:.T-]/g, '') + Math.floor(Math.random() * 1000);
        
        const fileExtension = originalFile.name.split('.').pop();
        const fileNameWithoutExt = originalFile.name.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z0-9]/g, '_');
        
        return `${fileNameWithoutExt}_ULTRA_${timestamp}_${dateString}_${nanoTime}_${randomPart1}_${randomPart2}_${randomPart3}.${fileExtension}`;
    };

    const handleDocFormSubmit = async (e) => {
        e.preventDefault();
        const formType = e.target.getAttribute('action');
        console.log(`Form submitted: ${formType}`);
        
        const button = e.target.querySelector('button[type="submit"]');
        button.textContent = "Uploading Please wait...";
        button.disabled = true;

        // Debug: Check our state values
        console.log("Debug - selectedFile:", selectedFile);
        console.log("Debug - uniqueFileName:", uniqueFileName);
        console.log("Debug - buttonName:", buttonName);

        if (!selectedFile) {
            console.log("No file selected");
            alert("Please select a file first");
            button.textContent = "Upload";
            button.disabled = false;
            return;
        }

        if (!buttonName) {
            console.log("No button name selected");
            alert("Please select a document type (Homily or Bulletin)");
            button.textContent = "Upload";
            button.disabled = false;
            return;
        }

        // If for some reason uniqueFileName is empty, generate it now
        if (!uniqueFileName) {
            console.log("Warning: uniqueFileName is empty, generating now...");
            const now = new Date();
            const timestamp = now.getTime();
            const nanoTime = performance.now().toString().replace('.', '_');
            const randomPart1 = Math.random().toString(36).substring(2, 15);
            const dateString = now.toISOString().replace(/[:.T-]/g, '');
            
            const fileExtension = selectedFile.name.split('.').pop();
            const fileNameWithoutExt = selectedFile.name.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z0-9]/g, '_');
            
            const emergencyFileName = `${fileNameWithoutExt}_EMERGENCY_${timestamp}_${dateString}_${nanoTime}_${randomPart1}.${fileExtension}`;
            setUniqueFileName(emergencyFileName);
            console.log("Generated emergency filename:", emergencyFileName);
        }

        console.log("Final filename to be used:", uniqueFileName || "ERROR: Still no filename");

        let StorageLink = "";
        let finalFileName = uniqueFileName;

        // First attempt with the original generated filename
        console.log("Starting upload attempt with filename:", finalFileName);
        let { data, error } = await supabase.storage
            .from('docs')
            .upload(finalFileName, selectedFile, {
                upsert: false
            });

        // If we get a duplicate error, try up to 5 times with different filenames
        let attempts = 0;
        while (error && (error.statusCode === '409' || error.message.includes('already exists')) && attempts < 5) {
            attempts++;
            console.log(`Attempt ${attempts}: Duplicate detected, generating new filename...`);
            
            finalFileName = generateNewUniqueFilename(selectedFile);
            console.log(`Retry attempt ${attempts} with filename:`, finalFileName);
            
            const result = await supabase.storage
                .from('docs')
                .upload(finalFileName, selectedFile, {
                    upsert: false
                });
                
            data = result.data;
            error = result.error;
        }

        if (error) {
            console.log("Final upload error after all attempts:", error);
            alert(`Upload failed after ${attempts + 1} attempts: ${error.message}. Please try again.`);
            button.textContent = "Upload";
            button.disabled = false;
            return;
        }

        console.log("Upload successful:", data);
        console.log("Final filename used:", finalFileName);

        // Create signed URL with the final filename that was successfully uploaded
        const { data: signedUrlData, error: signedUrlError } = await supabase.storage
            .from('docs')
            .createSignedUrl(finalFileName, 60 * 60 * 24 * 7);

        if (signedUrlError) {
            console.log("Error creating signed URL:", signedUrlError);
            alert("Upload successful but failed to create access link.");
            button.textContent = "Upload";
            button.disabled = false;
            return;
        }

        StorageLink = signedUrlData.signedUrl;
        console.log("Signed URL created:", StorageLink);

        console.log("Saving to database...");
        const { dataForm, errorForm } = await supabase
        .from('docs')
        .insert([
            {
            btnName: buttonName,
            docLink: StorageLink,
            }
        ])
        .select();

        if (dataForm) {
            console.log("Document created successfully:", dataForm);
            // Clear the form and reset states
            setSelectedFile(null);
            setUniqueFileName("");
            setButtonName("");
            // Clear the file input
            const fileInput = e.target.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = "";
            
            fetchDocs(); // Refresh the document list
        }

        if (errorForm) {
            console.log("Error creating document:", errorForm);
            alert("File uploaded but failed to save to database. Please try again.");
        }
        
        // Reset the button text and state after upload
        button.textContent = "Upload";
        button.disabled = false;
    }

    
    return (
        <div className='SundayHomily'>
            {isAuthenticated && (
                <div>
                    <form action="bulletin" onSubmit={handleDocFormSubmit} className='docForm'>
                        <select
                            id="btnName"
                            value={buttonName}
                            onChange={(e) => setButtonName(e.target.value)}
                        >
                            <option value="">Select Type</option>
                            <option value="Homily">Homily</option>
                            <option value="Bulletin">Bulletin</option>
                        </select>
                        <input 
                            type="file" 
                            id="fileName" 
                            onChange={handleFileSelection}
                            accept=".pdf,.doc,.docx"
                            key={selectedFile ? selectedFile.name : 'empty'} // Force re-render
                        />
                        
                        {/* Debug info for user */}
                        {selectedFile && (
                            <div style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                                <p>Selected: {selectedFile.name}</p>
                                <p>Upload as: {uniqueFileName.substring(0, 50)}...</p>
                            </div>
                        )}

                        <button className='MainBTN' type='submit'>Upload</button>
                    </form>
                </div>
            )}

            {fetchError && <p>{fetchError}</p>}
            {docs && (
                <ul>
                    {docs
                        .map((doc) => (
                            <li key={doc.id}>
                                <a
                                    className='MainBTN'
                                    href={doc.docLink}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    📄{doc.btnName}
                                </a>
                                {isAuthenticated && (
                                    <button
                                        onClick={async () => {
                                            const { error } = await supabase
                                                .from('docs')
                                                .delete()
                                                .eq('id', doc.id);

                                            if (error) {
                                                console.log("Error deleting document:", error);
                                            } else {
                                                setDocs(docs.filter((d) => d.id !== doc.id));
                                                console.log("Document deleted successfully");
                                            }
                                        }}
                                    >
                                        Delete
                                    </button>
                                )}
                            </li>
                        ))}
                </ul>
            )}

            {/* <p className='span2'>03/16/2025</p>

            <main>
                <a className='MainBTN' href={`/assets/Homily/H2025-3-30.docx`} download>
                📄Read Homily  
                </a>

                <a className='MainBTN' href={`/assets/Bulletin/2025/2025-3-30.pdf`} target="_blank" rel="noopener noreferrer">📄View Bulletin 
                 </a>
            </main> */}
        </div>
    );
}

export default Homily;